<script>
    import { onNavigate } from '$app/navigation';

    onNavigate((navigation) => {
        if (!navigation.to?.url.pathname.startsWith('/puzzles')) return;

        // @ts-ignore
        if (!document.startViewTransition) return;

        return new Promise((resolve) => {
            // @ts-ignore
            document.startViewTransition(async () => {
                resolve();
                await navigation.complete;
            });
        });
    });
</script>

<slot />
